module.exports = __webpack_public_path__ + "img/pic_dianfanbao1.a0ce0d7a.png";